// gHeader_navBtnをクリックすると、overlayが発動
import {Anim} from '/assets/js/modules/Anim.js';

const example = new Anim('.overlay');
$(document).on('click', '.gHeader_navBtn', async () => {
	console.log('before anim', example.isEnter)
	await example.toggle();
	console.log('after anim', example.isEnter)
})